import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("dataops.job_executions_history"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { staticClass: "mt-1" },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VRow,
                { attrs: { "no-gutters": "", justify: "end" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        VMenu,
                        {
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "200px",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    VTextField,
                                    _vm._g(
                                      {
                                        attrs: {
                                          "append-icon": "event",
                                          readonly: "",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                        },
                                        model: {
                                          value: _vm.date,
                                          callback: function ($$v) {
                                            _vm.date = $$v
                                          },
                                          expression: "date",
                                        },
                                      },
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.menu,
                            callback: function ($$v) {
                              _vm.menu = $$v
                            },
                            expression: "menu",
                          },
                        },
                        [
                          _c(VDatePicker, {
                            on: {
                              input: function ($event) {
                                _vm.menu = false
                              },
                            },
                            model: {
                              value: _vm.date,
                              callback: function ($$v) {
                                _vm.date = $$v
                              },
                              expression: "date",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "ml-1 btn-inca-secondary",
                          attrs: { dense: "", outlined: "" },
                          on: { click: _vm.buscar },
                        },
                        [
                          _c(VIcon, { attrs: { small: "" } }, [
                            _vm._v("mdi-magnify"),
                          ]),
                          _vm._v(" Buscar "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              [
                _c(VContainer, {
                  staticClass: "justify-center",
                  attrs: { fluid: "" },
                }),
                _c(
                  VRow,
                  [
                    _c(
                      VCol,
                      [
                        _c(
                          VCard,
                          [
                            _c(
                              VRow,
                              [
                                _c(
                                  VCol,
                                  [
                                    _c(
                                      VCardText,
                                      [
                                        _c(VTreeview, {
                                          attrs: {
                                            items: _vm.processedData,
                                            "return-object": "",
                                            "open-all": "",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "label",
                                              fn: function (ref) {
                                                var item = ref.item
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openDialog(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.jobName) +
                                                          " " +
                                                          _vm._s(item.version)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "append",
                                              fn: function (ref) {
                                                var item = ref.item
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.componentName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatTime(
                                                                item.startTime
                                                              )
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.formatTime(
                                                                  item.endTime
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "flex-grow": "1",
                                                            "min-width": "50px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VProgressLinear,
                                                            {
                                                              attrs: {
                                                                value:
                                                                  _vm.calcularPorcentaje(
                                                                    item.startTime,
                                                                    item.endTime
                                                                  ),
                                                                color: "green",
                                                                height: "20",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.calcularTiempoTranscurrido(
                                                                      item.startTime,
                                                                      item.endTime
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      item.state === "SUCCESS"
                                                        ? _c(
                                                            VChip,
                                                            {
                                                              attrs: {
                                                                color: "green",
                                                                outlined: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.state
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : item.state ===
                                                          "FAILED"
                                                        ? _c(
                                                            VChip,
                                                            {
                                                              attrs: {
                                                                color: "red",
                                                                outlined: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.state
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : item.state ===
                                                          "DISABLED"
                                                        ? _c(
                                                            VChip,
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "default",
                                                                outlined: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.state
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(VDivider, { attrs: { vertical: "" } }),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c(VCardText, [
                                      _vm.selectedItem
                                        ? _c(
                                            "div",
                                            [
                                              _c("h3", [
                                                _vm._v("Detalle del Ítem:"),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Nombre del Trabajo: " +
                                                    _vm._s(
                                                      _vm.selectedItem.jobName
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "ID del Trabajo: " +
                                                    _vm._s(
                                                      _vm.selectedItem.taskID
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Nombre del padre: " +
                                                    _vm._s(
                                                      _vm.obtenerNombreComponentePadre(
                                                        _vm.selectedItem
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Estado: " +
                                                    _vm._s(
                                                      _vm.selectedItem.state
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Versión: " +
                                                    _vm._s(
                                                      _vm.selectedItem
                                                        .versionName
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Inicio: " +
                                                    _vm._s(
                                                      _vm.formatTime(
                                                        _vm.selectedItem
                                                          .startTime
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Fin: " +
                                                    _vm._s(
                                                      _vm.formatTime(
                                                        _vm.selectedItem.endTime
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "Mensaje: " +
                                                    _vm._s(
                                                      _vm.selectedItem.message
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v("Tiempo transcurrido: "),
                                              ]),
                                              _c(VProgressLinear, {
                                                attrs: {
                                                  value: _vm.calcularPorcentaje(
                                                    _vm.selectedItem.startTime,
                                                    _vm.selectedItem.endTime
                                                  ),
                                                  color: "green",
                                                  height: "20",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var value = ref.value
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.calcularTiempoTranscurrido(
                                                                  _vm
                                                                    .selectedItem
                                                                    .startTime,
                                                                  _vm
                                                                    .selectedItem
                                                                    .endTime
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  2111483067
                                                ),
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("div", [
                                            _vm._v(
                                              " Seleccione un ítem para ver los detalles. "
                                            ),
                                          ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }